import React, { useContext } from 'react';
import { Box, Grid, Button } from '@mui/material';
import { ReactComponent as CustomIcon } from '../../images/logout.svg';
import { AuthContext } from '../../Auth';
import { useSelector, useDispatch } from 'react-redux';
import { clearProfileInfo, setFacturacionAutomatica } from '../../slices/profileSlice';
import Swal from 'sweetalert2'
import interrogationImg from '../../images/interrogation.svg'
import { useTranslation } from 'react-i18next';

const LoggedIn = () => {
  
  const { logout } = useContext(AuthContext);
  const dispatch = useDispatch();
  const profile = useSelector(state => state.profile);
  const { t } = useTranslation();
  
  const handleLogout = () => {
    logout();
  }

  const handleOmitClick = () => {
    Swal.fire({
      title: t('loggedin.rfc.modalTitle'),
      text: t('loggedin.rfc.modalText', {rfc: profile.rfc}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('loggedin.rfc.modalButtonConfirm'),
      cancelButtonText: t('swal.btn.cancel'),
      reverseButtons: true,
      customClass: {
          confirmButton: 'btn-blue',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(setFacturacionAutomatica(false));
      }
    });
  };

  return (
    <Box id="loggedin" sx={{ p: 3, border: '1px ', borderRadius: '4px' }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <div className="namefield">Nombre</div>
          <div className="valuefield">{profile.name}</div>
        </Grid>
        <Grid item xs={6}>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            sx={{ height: '100%', textAlign: 'center', mt: 2 }}
          >
            <Button
              sx={{
                textTransform: 'none',
                fontFamily: 'Patua One',
                height: 40
              }}
              onClick={handleLogout}
              color="gray"
              variant="outlined"
              startIcon={<CustomIcon />}
            >
              Cerrar Sesión
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="namefield" style={{ marginTop: 16 }}>Correo</div>
          <div className="valuefield">{profile.email}</div>
        </Grid>
      </Grid>
      {profile.rfc !== null && profile.facturacionAutomatica ? (
      <div className='disclaimer'>
        <img src={interrogationImg} alt="question icon" height="14px" width="14px"/>
        <p>
          {t('loggedin.rfc.info', {rfc: profile.rfc})}
          <span style={{ color: '#FE9C43', textDecoration: 'underline', cursor: 'pointer'}} onClick={handleOmitClick}>
            {t('loggedin.rfc.btnText')}
          </span>.
        </p>
      </div>
    ) : null}

    </Box>
  );
};

export default LoggedIn;
